import React, { forwardRef } from 'react';

import { BaseMenuOption } from 'src/editor/toolbars/menus/BaseMenuOption';
import type { CommonMenuItemProps } from 'src/editor/toolbars/menus/types';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';
import { useEditor } from 'src/layout-engine';
import { useEditingMode } from 'src/store/document/selectors';

interface DeleteTableColumnsMenuItemProps extends CommonMenuItemProps {
  numberOfColumns: number;
}

export const DeleteTableColumnsMenuItem = forwardRef(function DeleteTableColumnsMenuItem(
  props: DeleteTableColumnsMenuItemProps,
  ref: React.Ref<HTMLLIElement>
): JSX.Element {
  const { closeRootMenu, numberOfColumns, ...rest } = props;
  const editor = useEditor();
  const currentUserId = useCurrentUserId();
  const { editingMode } = useEditingMode();
  const { AuthorizedTransforms } = useAuthorizedTransforms();

  const isMultipleColumns = numberOfColumns > 1;
  const label = isMultipleColumns ? `Delete ${numberOfColumns} columns` : `Delete column`;

  function deleteTableColumns(): void {
    if (!editingMode || !currentUserId) return closeRootMenu();

    AuthorizedTransforms.deleteTableColumns(editor, { authorId: currentUserId, editingMode });
    ClientTransforms.focus(editor);
    closeRootMenu();
  }

  return <BaseMenuOption ref={ref} label={label} onClick={deleteTableColumns} {...rest} />;
});
